import { Visibility, VisibilityOff } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import {
	SecretBoxIconButton,
	SecretBoxInput,
	SecretBoxLabel,
	SecretBoxValue,
	SecretBoxValueProps,
	SecretBoxWrapper,
	SecretBoxInputProps,
	SecretBoxTooltip,
} from "./style";

interface SecretBoxProps extends SecretBoxInputProps, SecretBoxValueProps {
	label?: string | React.ReactNode;
	defaultShow?: boolean;
	value: string;
	tooltip?: string | React.ReactNode;
}

export default function SecretBox({
	width,
	height,
	backgroundColor,
	value,
	color,
	defaultShow,
	label,
	tooltip,
}: SecretBoxProps) {
	const [show, setShow] = useState<boolean>(false);

	useEffect(() => {
		if (defaultShow) {
			setShow(defaultShow);
		}
	}, []);

	const onClickIcon = () => {
		setShow(!show);
	};

	return (
		<SecretBoxWrapper>
			<SecretBoxLabel>{label}</SecretBoxLabel>
			<SecretBoxInput width={width} backgroundColor={backgroundColor}>
				<SecretBoxValue color={color} height={height}>
					{show ? value : "●●●●●●●●●●●●●●●"}
				</SecretBoxValue>
				<SecretBoxIconButton onClick={onClickIcon}>
					{show ? <Visibility /> : <VisibilityOff />}
				</SecretBoxIconButton>
			</SecretBoxInput>
			<SecretBoxTooltip>{tooltip}</SecretBoxTooltip>
		</SecretBoxWrapper>
	);
}
